import styled from 'styled-components';
import { breakpoint } from '../../Themes/screensize';
import { IThemePalette } from '../../Themes/interfaces';

export const panelColours = (palette: IThemePalette) => ({
  panel: {
    background: palette.neutral.gray[60]
  }
});

export const Panel = styled.div`
  background-color: ${({ theme }) => theme.colours.panel.background};
  white-space: nowrap;
  margin: 0.5rem;
  border: none;
  border-radius: 0.25rem;
  padding: 1.5rem;
  display: flex;
  gap: 1.25rem;
  align-items: center;
  vertical-align: middle;
  text-align: left;
  box-sizing: border-box;
  @media (max-width: ${breakpoint.mobile}) {
    white-space: normal;
    flex-direction: column;
    gap: 0.05rem;
  }
`;
